export { default as $itksnap } from './_itksnap.json'
export { default as $slicer3d } from './_slicer3d.json'
export { default as actc } from './actc.json'
export { default as batlow } from './batlow.json'
export { default as bcgwhw_dark } from './bcgwhw_dark.json'
export { default as bcgwhw } from './bcgwhw.json'
export { default as blue2red } from './blue2red.json'
export { default as blue2magenta } from './blue2magenta.json'
export { default as blue2cyan } from './blue2cyan.json'
export { default as bluegrn } from './bluegrn.json'
export { default as blue } from './blue.json'
export { default as bone } from './bone.json'
export { default as bronze } from './bronze.json'
export { default as cet_l17 } from './cet_l17.json'
export { default as cividis } from './cividis.json'
export { default as cool } from './cool.json'
export { default as copper2 } from './copper2.json'
export { default as copper } from './copper.json'
export { default as ct_airways } from './ct_airways.json'
export { default as ct_artery } from './ct_artery.json'
export { default as ct_bones } from './ct_bones.json'
export { default as ct_brain_gray } from './ct_brain_gray.json'
export { default as ct_brain } from './ct_brain.json'
export { default as ct_cardiac } from './ct_cardiac.json'
export { default as ct_head } from './ct_head.json'
export { default as ct_kidneys } from './ct_kidneys.json'
export { default as ct_liver } from './ct_liver.json'
export { default as ct_muscles } from './ct_muscles.json'
export { default as ct_scalp } from './ct_scalp.json'
export { default as ct_skull } from './ct_skull.json'
export { default as ct_soft } from './ct_soft.json'
export { default as ct_soft_tissue } from './ct_soft_tissue.json'
export { default as ct_surface } from './ct_surface.json'
export { default as ct_vessels } from './ct_vessels.json'
export { default as ct_w_contrast } from './ct_w_contrast.json'
export { default as cubehelix } from './cubehelix.json'
export { default as electric_blue } from './electric_blue.json'
export { default as freesurfer } from './freesurfer.json'
export { default as ge_color } from './ge_color.json'
export { default as gold } from './gold.json'
export { default as gray } from './gray.json'
export { default as green } from './green.json'
export { default as green2cyan } from './green2cyan.json'
export { default as green2orange } from './green2orange.json'
export { default as hotiron } from './hotiron.json'
export { default as hot } from './hot.json'
export { default as hsv } from './hsv.json'
export { default as inferno } from './inferno.json'
export { default as jet } from './jet.json'
export { default as kry } from './kry.json'
export { default as linspecer } from './linspecer.json'
export { default as lipari } from './lipari.json'
export { default as magma } from './magma.json'
export { default as mako } from './mako.json'
export { default as navia } from './navia.json'
export { default as nih } from './nih.json'
export { default as plasma } from './plasma.json'
export { default as random } from './random.json'
export { default as red } from './red.json'
export { default as redyell } from './redyell.json'
export { default as rocket } from './rocket.json'
export { default as surface } from './surface.json'
export { default as thermal } from './thermal.json'
export { default as turbo } from './turbo.json'
export { default as violet } from './violet.json'
export { default as viridis } from './viridis.json'
export { default as warm } from './warm.json'
export { default as winter } from './winter.json'
export { default as x_rain } from './x_rain.json'
export { default as afni_blues_inv } from './afni_blues_inv.json'
export { default as afni_reds_inv } from './afni_reds_inv.json'
export { default as roi_i256 } from './roi_i256.json'
